import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import muiTheme from './theme/muiTheme';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import UserManagement from './components/UserManagement';
import AdminManagement from './components/AdminManagement';
import ProductManagement from './components/ProductManagement';
import CategoryManagement from './components/CategoryManagement';
import OrderManagement from './components/OrderManagement';
import PackagingManagement from './components/PackagingManagement';
import FullControl from './components/FullControl';
import POSSystem from './components/POSSystem';
import GiftShopManagement from './components/GiftShopManagement';
import CouponManagement from './components/CouponManagement';
import BannerManagement from './components/BannerManagement';
import MissingProducts from './components/MissingProducts';
import AdminReports from './components/AdminReports';
import ERPDashboard from './components/ERPDashboard';
import WhatsAppMessages from './components/WhatsAppMessages';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import UpdateNotification from './components/UpdateNotification';
import './App.css';



function App() {
  // Set document title
  React.useEffect(() => {
    document.title = 'ادمن الصادق';
  }, []);

  // Create RTL theme
  const rtlTheme = createTheme({
    ...muiTheme,
    direction: 'rtl',
    typography: {
      ...muiTheme.typography,
      fontFamily: '"Cairo", "Arial", sans-serif'
    }
  });

  return (
    <ThemeProvider theme={rtlTheme}>
      <CssBaseline />
      <SnackbarProvider 
        maxSnack={3}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        autoHideDuration={5000}
      >
        <div dir="rtl" style={{ direction: 'rtl' }}>
        {/* PWA Update Notification - Shows across all pages */}
        <UpdateNotification />
        
        <Router>
        <Box sx={{ minHeight: '100vh' }}>
          <Routes>
            {/* Home Page - Admin Login */}
            <Route path="/" element={<AdminLogin />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <AdminProtectedRoute>
                <AdminDashboard />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <AdminProtectedRoute>
                <UserManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/admins" element={
              <AdminProtectedRoute>
                <AdminManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/products" element={
              <AdminProtectedRoute>
                <ProductManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/categories" element={
              <AdminProtectedRoute>
                <CategoryManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/orders" element={
              <AdminProtectedRoute>
                <OrderManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/packaging" element={
              <AdminProtectedRoute allowPackagingAdmin={true}>
                <PackagingManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/full-control" element={
              <AdminProtectedRoute>
                <FullControl />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/pos" element={
              <AdminProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <POSSystem />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/giftshop" element={
              <AdminProtectedRoute>
                <GiftShopManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/coupons" element={
              <AdminProtectedRoute>
                <CouponManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/banners" element={
              <AdminProtectedRoute>
                <BannerManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/missing-products" element={
              <AdminProtectedRoute allowInventoryAdmin={true}>
                <MissingProducts />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/reports" element={
              <AdminProtectedRoute>
                <AdminReports />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/erp" element={
              <AdminProtectedRoute allowPackagingAdmin={false} allowInventoryAdmin={false}>
                <ERPDashboard />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/whatsapp" element={
              <AdminProtectedRoute>
                <WhatsAppMessages />
              </AdminProtectedRoute>
            } />
            
            {/* Redirect any unknown routes to admin login */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Box>
      </Router>
      </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
